module.exports = "<h3>\n    <span routerLink=\"/schemas/overview\" class=\"link\">\n        <i class=\"fa fa-arrow-alt-circle-left\"></i>\n    </span>\n    Edit {{schema.name}} - {{base.name}}\n</h3>\n<hr class=\"mt-0\"/>\n<schema [base]=\"base\" [schema]=\"schema\" [moments]=\"moments\" [settings]=\"settings\"></schema>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/schemas/edit.component.html
// module id = 613
// module chunks = 1